import { TRule } from '../../typings';

export const ATRAXION_PRICELIST_RULESET: TRule[] = [
  {
    type: 'rule.map',
    sourceKey: "c.['Eancode']",
    destination: 'product',
    targetKey: 'ean',
  },
  {
    type: 'rule.map',
    sourceKey: "c.['Id']",
    destination: 'product',
    targetKey: 'supplierCode',
  },
  {
    type: 'rule.template',
    destination: 'product',
    targetKey: 'brand',
    template: '',
  },
  {
    type: 'rule.map',
    sourceKey: "c.['Prijs']",
    destination: 'product',
    targetKey: 'priceEUR',
    outputType: 'number',
  },
];
